import {BodyComponent} from "../components/body/body-component";
import {DropzoneComponent} from "../components/dropzone/dropzone-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {FormFieldModelSelector} from "../components/form-field-model-selector/form-field-model-selector";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModInternalHeader} from "../components/mod-internal-header/mod-internal-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {FormFieldFiles} from "../components/form-field-files/form-field-files";
import {FormFieldRating} from "../components/form-field-rating/form-field-rating";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-form-field-files",FormFieldFiles);
GvfUiService.registerComponent(".js-form-field-rating",FormFieldRating);
GvfUiService.registerComponent(".js-form-field-model-selector",FormFieldModelSelector);
GvfUiService.registerComponent(".js-dropzone",DropzoneComponent);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-internal-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-dynamic-form",()=>import("../components/mod-dynamic-form/mod-dynamic-form"));
GvfUiService.registerDelayedComponent(".js-mod-hero",()=>import("../components/mod-hero/mod-hero"));
GvfUiService.registerDelayedComponent(".js-mod-clients",()=>import("../components/mod-clients/mod-clients"));
GvfUiService.registerDelayedComponent(".js-mod-plan",()=>import("../components/mod-plan/mod-plan"));
GvfUiService.registerDelayedComponent(".js-mod-welcome",()=>import("../components/mod-welcome/mod-welcome"));
GvfUiService.registerDelayedComponent(".js-mod-services",()=>import("../components/mod-services/mod-services"));
GvfUiService.registerDelayedComponent(".js-mod-remember-cta",()=>import("../components/mod-remember-cta/mod-remember-cta"));
GvfUiService.registerDelayedComponent(".js-mod-data",()=>import("../components/mod-data/mod-data"));
GvfUiService.registerDelayedComponent(".js-mod-testimonials",()=>import("../components/mod-testimonials/mod-testimonials"));
GvfUiService.registerDelayedComponent(".js-mod-news",()=>import("../components/mod-news/mod-news"));
GvfUiService.registerDelayedComponent(".js-mod-faqs",()=>import("../components/mod-faqs/mod-faqs"));
GvfUiService.registerDelayedComponent(".js-mod-hero",()=>import("../components/mod-hero/mod-hero"));
GvfUiService.registerDelayedComponent(".js-mod-hero-form",()=>import("../components/mod-hero/mod-hero-form"));
GvfUiService.registerDelayedComponent(".js-mod-custom-form",()=>import("../components/mod-custom-form/mod-custom-form"));
GvfUiService.registerDelayedComponent(".js-mod-job-position-list",()=>import("../components/mod-job-position-list/mod-job-position-list"));
